import request from '@/utils/request'

const basePath = '/api/review/result'


/**
 * 根据答题卡id查询批阅结果
 * @param answerSheetId
 * @returns {*}
 */
export function findResultByAnswerSheetId(answerSheetId) {
    return request({
        url: `${basePath}/${answerSheetId}`,
        method: 'GET'
    })
}